import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { SessionContextProvider } from '@supabase/auth-helpers-react'; // New import
import { supabase } from './supabaseClient'; // New import (create if missing, see below)
import { isPerfDiagnosticsEnabled, logPerfEvent, roundPerfMs } from './perfDiagnostics';

const bootstrapStartedAtMs = typeof performance !== 'undefined' ? performance.now() : Date.now();
if (typeof window !== 'undefined' && isPerfDiagnosticsEnabled()) {
  const navigationEntry = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
  if (navigationEntry) {
    logPerfEvent('navigation_bootstrap', {
      pathname: window.location.pathname,
      ttfbMs: roundPerfMs(navigationEntry.responseStart),
      domContentLoadedMs: roundPerfMs(navigationEntry.domContentLoadedEventEnd),
      loadEventMs: roundPerfMs(navigationEntry.loadEventEnd),
      transferSize: navigationEntry.transferSize,
    });
  }
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <SessionContextProvider supabaseClient={supabase}> {/* New wrapper */}
      <App />
    </SessionContextProvider>
  </React.StrictMode>
);

if (typeof window !== 'undefined' && isPerfDiagnosticsEnabled()) {
  window.requestAnimationFrame(() => {
    window.requestAnimationFrame(() => {
      logPerfEvent('react_bootstrap_commit', {
        pathname: window.location.pathname,
        bootstrapToPaintMs: roundPerfMs(
          (typeof performance !== 'undefined' ? performance.now() : Date.now()) - bootstrapStartedAtMs
        ),
      });
    });
  });
}
